import { Injectable } from "@angular/core";
import { StringUtilsHelper } from "./strings.helper";

@Injectable({
    providedIn: 'root'
})
export class ArrayHelper {
    private static  cards: any[] = []; // Arreglo privado para almacenar las tarjetas
    static isSelected: boolean[] = [];
    static selectedIndex: number;

    static setCards(list: any){
        this.cards = list;
    }

    static getCards() {
        return this.cards;
    }

    static getCard(index: number) {
        return this.cards[index];
    }

    static getLength(){
        return this.cards.length;
    }

    static addCard(obj: any) {
        this.cards.push(obj);
        this.isSelected.push(false); // Agregar un nuevo estado para la nueva tarjeta
    }

    static deleteCard(obj: any, key?: string) {
        let pos: number = -1;
        this.cards.find((elem, index) => {
            if(StringUtilsHelper.notNullOrUndefinedOrEmpty(key)){
                if (elem[key] === obj[key]) {
                    pos = index;
                }
            } else {
                if (elem === obj) {
                    pos = index;
                }
            }            
        });
        this.selectedIndex = pos;

        this.cards.splice(pos, 1);
        this.isSelected.splice(pos, 1); // Eliminar el estado correspondiente a la tarjeta eliminada
    }
}